<template>
  <div class="doctor-box">
    <div class="doctor-tab-list">
      <div class="doctor-tab" v-for="item in tab_list" @click="handleChangeTab(item.key)" :key="item.key" :class="{'tab-active':active_type == item.key}">{{item.value}}</div>
    </div>
    <loadMore
      class="issue-load-more"
      v-if="order_list.length>0"
      :onLoadMore="onLoadMore"
      :enableLoadMore="enableLoadMore"
    >
      <div
        class="doctor-list"
        :class="{'pad-bottom':item.status == 3}"
        v-for="(item,index) in order_list"
        :key="index"
        @click="handleToDetail(item.id,item.status)"
      >
        <div class="doctor-list-top flex_s_c">
          <img :src="item.avatar" alt />
          <div class="doctor-detail font-85">{{item.docname?item.docname:''}} <span class="order-type" :class="{'is_graphic':item.type == 1,'is_phone':item.type == 2,'is_video':item.type == 3}">{{item.type | order_type}}</span></div>
          <div
            class="doctor-num"
            :class="{'is_cancel':item.status == 1 || item.status == 4,'is_replay':item.status == 2||item.status == 5,'is_online':item.status == 3}"
          >{{item.status | charge_status}}</div>
        </div>
        <div class="shop-box"></div>
        <div class="shop-list">
          <div class="shop-list-detail flex_s_c">
            <div class="s-l-d-left">问诊费用：</div>
            <div class="s-l-d-right font-85">{{(item.charge_amount).toFixed(2)}}元</div>
          </div>
          <div class="shop-list-detail flex_s_c">
            <div class="s-l-d-left font-65">支付时间：</div>
            <div class="s-l-d-right font-85">{{item.time}}</div>
          </div>
          <div class="shop-footer" @click.stop="gobuchong(item)" v-if="(item.status == 3 && item.is_case == 0)||item.status == 5">{{item.status == 3 && item.is_case == 0?'补充资料':item.status == 5?'去支付':''}}</div>
        </div>
      </div>
    </loadMore>
    <div class="doctor-null flex_s_c_w" v-if="order_list.length == 0">
      <img src="../../../static/icons/wenzhen@3x.jpg" alt />
      <div class="doctor-null-txt font-85">暂无问诊记录</div>
      <div class="doctor-null-btn" @click="handleToHome">找名医</div>
    </div>
  </div>
</template>
<script>
import http from "../../request/http";
import { formatDate } from "../../utils/index";
import loadMore from "../loadMore";
export default {
  data() {
    return {
      tab_list:[{key:1,value:'待支付'},{key:2,value:'已支付'},{key:3,value:'问诊中'},{key:4,value:'取消/完成'}],
      order_list: [],
      enableLoadMore: true,
      page: 1,
      active_type:1
    };
  },
  created() {
    this.getOrderList();
  },
  components: {
    loadMore,
  },
  filters: {
    charge_status(val) {
      let txt = "";
      switch (val) {
        case "1":
          txt = "已取消";
          break;
        case "2":
          txt = "待回复";
          break;
        case "3":
          txt = "问诊中";
          break;
        case "4":
          txt = "已结束";
          break;
        case "5":
          txt = "待支付";
          break;
        default:
          txt = "";
      }
      return txt;
    },
    order_type(val) {
      let txt = "";
      switch (val) {
        case "1":
          txt = "图文问诊";
          break;
        case "2":
          txt = "电话咨询";
          break;
        case "3":
          txt = "视频问诊";
          break;
        default:
          txt = "";
      }
      return txt;
    },
  },
  methods: {
    gobuchong(obj){
      if(obj.status == 5){
        this.$router.push("/second_pay?id=" + obj.id);
      }else if(obj.status == 3){
        let data = {
          doctorid:obj.docid,
          pid:obj.pid,
          orderid:obj.id,
          name:obj.docname
        }
        this.$router.push({path:"/pat_content",query:data});
      }
    },
    handleChangeTab(tab){
      this.active_type = tab;
      this.getOrderList();
    },
    handleToHome() {
      this.$router.push("/");
    },
    onLoadMore(done) {
      setTimeout(() => {
        if (!this.enableLoadMore) {
          return;
        }
        this.page = this.page + 1;
        this.getOrderList(() => {
          done();
        });
      }, 200);
    },
    getOrderList(done = function () {}) {
      let data = {
        pageIndex: this.page,
        status:this.active_type
      };
      http
        .post("/api/wap/user/orderlist", data)
        .then((res) => {
          done();
          if (res.data) {
            res.data.forEach((v) => {
              v.time = formatDate(v.ctime * 1000);
            });
            if (res.data.length < 10) {
              this.enableLoadMore = false;
            }
            if (this.page == 1) {
              this.order_list = res.data;
            } else {
              this.order_list = this.order_list.concat(res.data);
            }
          } else {
            this.order_list = [];
          }
        })
        .catch((err) => {
          done();
          console.log(err);
        });
    },
    handleToDetail(id,status) {
      if(status == 5){
        this.$router.push("/second_pay?id=" + id);
      }else{
        this.$router.push("/issue_detail?id=" + id);
      }
    },
  },
};
</script>
<style scoped>
@import "./doctor.css";
@import "./issue.css";
.issue-load-more {
  height:calc(100vh - 2.4rem);
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  transition-duration: 300ms;
}
.doctor-box{
  padding:0;
}
.doctor-list{
  width: 100vw;
  border-radius: 0;
  border:none;
  padding:0.85rem 1rem 1rem;
  height: auto;
}
.doctor-list.pad-bottom{
  padding-bottom: 0.75rem;
}
.order-type{
  height: 1rem;
  line-height: 1rem;
  font-size: 0.6rem;
  margin-left: 0.3rem;
  color:#fff;
  display: inline-block;
  padding:0 0.15rem 0 0.2rem;
  border-radius: 0.2rem;
}
.order-type.is_graphic{
  background: #00CEFF;
}
.order-type.is_phone{
  background: #7072FB;
}
.order-type.is_video{
  background: #BF79F3;
}
.s-l-d-left{
  color:#8C8C8C;
}
.shop-footer{
  width: 100%;
  height: 1.2rem;
  line-height: 1.2rem;
  text-align: right;
  margin-top: 0.4rem;
  color:#1890FF;
  font-size: 0.7rem;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.shop-footer::after{
  content: '';
  display: inline-block;
  width: 0.3rem;
  height: 0.3rem;
  border-top: 0.07rem solid #1890FF;
  border-right: 0.07rem solid #1890FF;
  transform: rotate(45deg);
}
.doctor-null{
  height: calc(100vh - 2.9rem);
  margin-top: 0.5rem;
  background: #fff;
}
</style>



// WEBPACK FOOTER //
// src/pages/user/my_issue.vue